import { render, staticRenderFns } from "./info-header.vue?vue&type=template&id=901428f0"
import script from "./info-header.vue?vue&type=script&lang=js"
export * from "./info-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports